import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getMostViewedAdvertTypesChart } from "./Services";



export const useGetMostViewAdvertTypes= (filter:any) => {
  const query = useQuery(
    [endpoints.getMostViewedAdvertTypesChart,filter],
    () => {
      return getMostViewedAdvertTypesChart(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};
